import { render } from "./ViewInterviewAttachments.vue?vue&type=template&id=12fa5e51&scoped=true"
import script from "./ViewInterviewAttachments.vue?vue&type=script&lang=js"
export * from "./ViewInterviewAttachments.vue?vue&type=script&lang=js"

import "./ViewInterviewAttachments.vue?vue&type=style&index=0&id=12fa5e51&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fa5e51"]])

export default __exports__